export default __webpack_public_path__ + "src/images/packages/oceana-reserve/f89faaf3941345ec307102365cc89423-3.jpg";